export const HEALTH_BINGO_FLAG = "health_bingo";
export const HEALTH_BINGO_URL = "https://mc.walkingonearth.com";
export const HEALTH_BINGO_END = new Date("2026-05-21T00:00:00");

export function getHealthBingoUrl(): string {
  const token = localStorage.getItem("Authtoken");
  if (!token) return HEALTH_BINGO_URL;
  return `${HEALTH_BINGO_URL}?token=${encodeURIComponent(token)}`;
}
